// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetails .details-header,
.SystemUserDetails .details-header,
.PartnerUserDetails .details-header {
  display: flex;
  align-items: center;
}
.UserDetails .details-header .user-image,
.SystemUserDetails .details-header .user-image,
.PartnerUserDetails .details-header .user-image {
  margin-right: 16px;
}
.UserDetails .details-header .user-image .upload-image,
.SystemUserDetails .details-header .user-image .upload-image,
.PartnerUserDetails .details-header .user-image .upload-image {
  width: 40px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Users/Sidebar/UserDetails.scss"],"names":[],"mappings":"AAIE;;;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;;;EACE,kBAAA;AACN;AACM;;;EACE,WAAA;EACA,YAAA;AAGR","sourcesContent":[".UserDetails,\n.SystemUserDetails,\n.PartnerUserDetails {\n\n  .details-header {\n    display: flex;\n    align-items: center;\n\n    .user-image {\n      margin-right: 16px;\n\n      .upload-image {\n        width: 40px;\n        height: 40px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
